'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.filter("lov", function () {
  return function lovFilter(lovId, lovValues) {
    if (!lovId) {
      return null;
    }
    for (var i = 0; i < lovValues.length; i++) {
      if (lovId === lovValues[i].id) {
        return lovValues[i].label;
      }
    }
    return null;
  };
});
ngModule.filter("translateLov", function ($translate) {
  return function translateLov(lovId, lovName) {
    if (!lovId) {
      return null;
    }
    return $translate("lov." + lovName + "." + lovId);
  };
});
ngModule.filter("lovIdsIn", function () {
  return function lovIdsIn(lovs, ids) {
    if (lovs == null || ids == null) {
      return null;
    }
    return _.filter(lovs, function (lov) {
      return _.includes(ids, lov.id);
    });
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/filters/lov.js
// module id = 2704
// module chunks = 13